<template>
	<div class="nav">
		<!--<a href="">
			<img class="logo" src="../../img/dating/logo.png" />
			<h1 class="til">齐齐直播</h1>
		</a>-->
		<!--<button v-on:click="loadDown">下载</button>-->
		<a href="javascript:void(0)" v-on:click="toCenter">
			<img class="user" v-bind:src="userImg" />
			<span class="tologin" v-html="!isLogin?'请点击登录':HTMLEscape(userNick.slice(0,8))"></span>
		</a>
		<a v-on:click="toDating" class="toIndex" v-show="index!='dating'&&index!='bindPhone'">
			<img class="charge" src="../../img/dating/home.png" />
			<span>{{showRoomEntry?'返回房间':'返回大厅'}}</span>
		</a>
		<a v-on:click="toCenter" class="toIndex" v-show="index=='bindPhone'">
			<img class="charge" src="../../img/dating/home.png" />
			<span>&nbsp&nbsp返回</span>
		</a>
		<a v-on:click="toCare" class="mySub" v-show="index=='dating'">
			<img class="charge" src="../../img/dating/mySub.png" />
			<span>我关注的</span>
		</a>
		<div class="devide" v-show="index=='dating'"></div>
		<a href="javascript:void(0)" class="charge-wrap" v-on:click="toRecharge" v-show="showRecharge">
			<!--<img class="charge" src="../../img/dating/charge.png" />-->
			<span>充值</span>
		</a>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import passPort from '../../libs/passport'
	import cookie from '../../libs/cookie'
	export default {
		name: 'index',
		data() {
			return {
				showRecharge: true
			}
		},
		props:['index'],
		computed:{
			userImg(){
				if(!passPort.isLogin()){
					return 'https://static.qxiu.com/h5/static/userDefault.png'
				}else if(cookie.get('photo')){
					if(cookie.get('photo').slice(0,1)=='"'){
						return 'https://qiqi-resource-v6.qxiu.com'+cookie.get('photo').slice(1,-1).slice(29);
					}else if(cookie.get('photo') == 'null'||cookie.get('photo').indexOf('static.qxiu.com')!=-1){
						if(this.isxiaoxiong){
							return 'https://static.qxiu.com/h5/static/xiaoxiong.png'
						}else{
							return 'https://static.qxiu.com/h5/static/img/app.png'
						}
					}else{
						return 'https://qiqi-resource-v6.qxiu.com'+cookie.get('photo').slice(29);
					}
				}else{
					return this.isxiaoxiong?'https://static.qxiu.com/h5/static/xiaoxiong.png':'https://static.qxiu.com/h5/static/img/app.png'
				}
			},
			userNick(){
				return cookie.get('nick');
			},
			isLogin(){
				return passPort.isLogin();
			},
			showRoomEntry(){
				return this.querystr('roomid')
			},
			isxiaoxiong(){
				return cookie.get('isxiaoxiong')=='true'
			},
		},
		mounted() {
			var u = navigator.userAgent,
			isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
			if(isGooglePlay){
				this.showRecharge = false;
			}
		},
		methods: {
			querystr(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.href.slice(window.location.href.indexOf('?')).substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;
			},
			toCare(){
				if(passPort.isLogin()){
					location.hash="/care"
				}else{
					this.$store.commit('getCurview', 'loginmode')
				}
			},
			toDating(){
				if(this.showRoomEntry){
					location.href= location.protocol + "//h5.qxiu.com/room.html?roomid=" +this.showRoomEntry+ "&channelid=" +cookie.get('channelid');
				}else{
					location.hash="/"
				}
			},
			toCenter(){
				location.hash="/center"
			},
			toCenter() {
				if(passPort.isLogin()) {
					location.hash = "/center"
				} else {
					this.$store.commit('getCurview', 'loginmode')
				}
			},
			toRecharge() {
				if(passPort.isLogin()) {
					if((!cookie.get('wxopenid'))&&this.isWeixin()){
//						location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+location.protocol.slice(0,-1)+"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
						location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
					}else{
						location.href=location.protocol + "//h5.qxiu.com/index.html#/recharge"
					}
				} else {
					var that= this
					this.$store.commit('getTips', {con:'请在登录之后进行充值哦！',func:function(){
						sessionStorage.dtRecharge=true
						that.$store.commit('getCurview', 'loginmode')
						
					}})
				}
			},
			loadDown() {
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.nav {
		position: fixed;
		top: 0;
		box-sizing: border-box;
		height: 2.2rem;
		width: 15rem;
		background: #9E42FF;
		padding-left:0.48rem;
		z-index: 100;
		/*border-bottom: 1px solid #E9E9E9;*/
	}
	.logo {
		float: left;
		width: 1.46rem;
		height: 1.24rem;
	}
	
	.til {
		float: left;
		margin-left: 0.1rem;
		font-size: 0.64rem;
		font-weight: 200;
		letter-spacing: 2px;
		line-height: 1.24rem;
		color: #000;
	}
	
	button {
		float: left;
		width: 1.84rem;
		height: 0.8rem;
		color: #EE3F81;
		font-size: 0.52rem;
		line-height: 0.72rem;
		border: 2px solid #EE3F81;
		border-radius: 0.1rem;
		background: #fff;
		margin-top: 0.26rem;
		margin-left: 0.32rem;
	}
	
	.user{
		width: 1.4rem;
		height: 1.4rem;
		vertical-align: middle;	
		border-radius: 50%;	
	}
	
	.tologin{
		color: #fff;
		font-size: 0.48rem;
		line-height: 2.2rem;
		vertical-align: middle;
		margin-left: 0.2rem;
	}
	.charge-wrap{
		float: right;
		width: 2.4rem;
		height: 1.16rem;
		margin-top: 0.54rem;
		background: linear-gradient(to right,#FF7F6E,#FD2092);
		border-radius: 0.58rem;
		text-align: center;
	}
	.charge-wrap img{
		height: 0.7rem;
		vertical-align: middle;
	}
	.charge-wrap span{
		color: #fff;
		display: inline-block;
		line-height: 1.16rem;
		vertical-align: middle;
		font-size: 0.52rem;
	}
	
	.devide{
		float: right;
		width: 1px;
		height: 1.4rem;	
		margin: 0.4rem 0.46rem;
		background: #B16CFF;
	}
	
	.mySub{
		float: right;
		height: 100%;
		line-height: 2.2rem;
		margin: 0 0.48rem 0 0;
		color: #fff;
		font-size: 0.52rem;
	}
	.mySub img{
		width: 0.74rem;
		height: 0.66rem;
		vertical-align: middle;
	}
	.toIndex{
		float: right;
		width: 4rem;
		height: 100%;
		margin-left: 0.4rem;
		background: #6924B4;
		color: #fff;
		font-size: 0.52rem;
		line-height: 2.2rem;
	}
	.toIndex img{
		width: 0.74rem;
		height: 0.66rem;
		margin-left: 0.56rem;
		vertical-align: middle;
	}
</style>


// WEBPACK FOOTER //
// navTop.vue?72bb34d9